import React from "react";
import { Link } from "gatsby";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";

export default function MainExpertForm({ handleMainSignup, emailError }) {
  const [checked, setChecked] = React.useState(true);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState("");

  const SignupSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(3, "First Name must be 3 characters at minimum")
      .required("First Name is required"),
    last_name: Yup.string()
      .min(3, "Last Name must be 3 characters at minimum")
      .required("Last Name is required"),
    email: Yup.string()
      .email("Invalid email address format")
      .required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be 8 characters at minimum")
      .required("Password is required"),
    password2: Yup.string()
      .min(8)
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const onSubmitForm = async (formData) => {
    setError("");
    console.log("IN SUBMIT FORM");
    setIsSubmitting(true);
    if (!checked) {
      setError("Please agree to Terms and Policy");
      setIsSubmitting(false);
      return;
    }
    delete formData["password2"];

    handleMainSignup(formData);
    // setError("Invalid Form");
    // setIsSubmitting(false);
  };

  return (
    <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password2: "",
      }}
      validationSchema={SignupSchema}
      onSubmit={(data) => {
        onSubmitForm(data);
      }}
    >
      {({ touched, errors }) => (
        <Form>
          <label htmlFor="first_name">FIRST NAME</label>
          <Field
            type="text"
            name="first_name"
            placeholder="Enter First Name"
            className={`form-control ${
              touched.first_name && errors.first_name ? "is-invalid" : ""
            }`}
          />
          <ErrorMessage
            component="div"
            name="first_name"
            className="invalid-feedback"
          />
          <label htmlFor="last_name">LAST NAME</label>
          <Field
            type="text"
            name="last_name"
            placeholder="Enter Last Name"
            className={`form-control ${
              touched.last_name && errors.last_name ? "is-invalid" : ""
            }`}
          />

          <ErrorMessage
            component="div"
            name="last_name"
            className="invalid-feedback"
          />
          <label htmlFor="email">EMAIL</label>
          <Field
            type="email"
            name="email"
            placeholder="Enter Email"
            className={`form-control ${
              touched.email && errors.email ? "is-invalid" : ""
            }`}
          />
          <ErrorMessage
            component="div"
            name="email"
            className="invalid-feedback"
          />
          <label htmlFor="password">PASSWORD</label>
          <Field
            type="password"
            name="password"
            placeholder="Enter Password"
            className={`form-control ${
              touched.password && errors.password ? "is-invalid" : ""
            }`}
          />
          <ErrorMessage
            component="div"
            name="password"
            className="invalid-feedback"
          />
          <label htmlFor="confirmPassword">CONFIRM PASSWORD</label>
          <Field
            type="password"
            name="password2"
            placeholder="Confirm Password"
            className={`form-control ${
              touched.password2 && errors.password2 ? "is-invalid" : ""
            }`}
          />
          <ErrorMessage
            component="div"
            name="password2"
            className="invalid-feedback"
          />
          <label className="checkbox">
            <input
              type="checkbox"
              checked={checked}
              onChange={() => setChecked(!checked)}
              className="checkbox__input"
            />
            <span className="checkbox__checkmark"></span>
            <span>
              I have read and agree to MedAnswers'
              <Link to="/terms-of-service/experts">
                {" "}
                Terms of Service
              </Link> and <Link to="/privacy"> Privacy Policy</Link>.
            </span>
          </label>
          {emailError && <span style={{ color: "red" }}>{emailError}</span>}
          <button type="submit" className="continue expert">
            Continue as an Expert
          </button>
          <h6>
            Already have an Account? <a href="#">Sign in</a>
          </h6>
        </Form>
      )}
    </Formik>
  );
}
